import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SwapHorizontalCircleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"swap_horizontal_circle"}/>
}
